import React from 'react';
import Button from '@material-ui/core/Button';

const AnswerButton = (props) => {
    return (
        <Button className="p-chat__button-answer" variant="contained" color="primary"
                onClick={() => props.onClick(props.theme, props.text, props.next, props.route, props.id)}>
            {props.text}
        </Button>
    );
};

export default AnswerButton;
